import './App.css';
import Header from './components/Header'
import Footer from './components/Footer'
import { Outlet, Routes, Route } from "react-router-dom";
import Description from './pages/Project/Description';
import { BrowserRouter as Router } from 'react-router-dom';
import Design from './pages/Project/Design'
import Proof from './pages/Project/Proof'
import Contributions from './pages/Project/Contributions'
import TeamMembers from './pages/Team/TeamMembers';
import Sponsors from './pages/Team/Sponsors';
import Engineering from './pages/Project/Engineering';
import Results from './pages/Project/Results';
import Protocols from './pages/Lab/Protocols';
import Safety from './pages/Lab/Saftey';
import Parts from './pages/Lab/Parts';
import Model from './pages/Model/Model';
import Integrated from './pages/HumanPractices/Integrated';
import Outreach from './pages/HumanPractices/Outreach';
import Entrepreneurship from './pages/Entrepreneurship/Entrepreneurship';
import Attributions from './pages/Team/Attributions';
import Home from './pages/Home';
import Competition from './pages/Awards/Competition';
import MedalCriteria from './pages/Awards/MedalCriteria';


function Layout() {
  return (
      <div>

        <Header /> 
        <div className='content'>
        <Outlet />
        </div > 
        <Footer />
      </div> 
  );
}
function App() {
  return (
    <Router  basename={process.env.PUBLIC_URL}>
      <Routes>
        <Route path="/" element={<Layout />}>
        <Route path="/" element={<Home />} />
          <Route path="description" element={<Description />} />
          <Route path="design" element={<Design />} />
          <Route path="proof-of-concept" element={<Proof />} />
          <Route path="contributions" element={<Contributions />} />
          <Route path="engineering" element={<Engineering />} />
          <Route path="results" element={<Results />} />
          <Route path="protocols" element={<Protocols />} />
          <Route path="safety" element={<Safety />} />
          <Route path="parts" element={<Parts />} />
          <Route path="model" element={<Model />} />
          <Route path="human-practices" element={<Integrated />} />
          <Route path="outreach" element={<Outreach />} />
          <Route path="entrepreneurship" element={<Entrepreneurship />} />
          <Route path="attributions" element={<Attributions />} />
          <Route path="team" element={<TeamMembers />} />
          <Route path="sponsors" element={<Sponsors />} />
          <Route path="competition" element={<Competition />} />
          <Route path="medal-criteria" element={<MedalCriteria />} />

        </Route>
      </Routes>
    </Router>
  );
}

export default App;
